// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"467":"fa9315d8","821":"1a79a904"}[chunkId] + ".chunk.js");